import '@atlaskit/css-reset';
import React from 'react';
import { getHistory } from '@atlassian/ptc-common/store';
import StandaloneApp from '@atlassian/standalone-directory/standalone-app';
import { AppContext } from '@townsquare/app-context';
import { AuthCheck } from '@townsquare/auth';
import { AggRelayEnvironmentProvider } from '@townsquare/relay-utils/agg-environment';
import { Bootstrap } from './bootstrap/Bootstrap';
import { StatSigInit } from './bootstrap/StatSigInit';
const history = getHistory();
const App = (): React.JSX.Element => {
  return <AuthCheck>
			<AppContext.Provider value={{
      app: 'teams-isolated'
    }}>
				<AggRelayEnvironmentProvider>
					<Bootstrap>
						{({
            orgId,
            cloudId,
            accountId
          }) => <StatSigInit orgId={orgId} cloudId={cloudId} accountId={accountId}>
								<StandaloneApp appName="teams-isolated" history={history} />
							</StatSigInit>}
					</Bootstrap>
				</AggRelayEnvironmentProvider>
			</AppContext.Provider>
		</AuthCheck>;
};
export { App };